import { render } from "./CreateAuthorAccountForm.vue?vue&type=template&id=17719835"
import script from "./CreateAuthorAccountForm.vue?vue&type=script&lang=js"
export * from "./CreateAuthorAccountForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__